import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const SessionErrorScreen = ({ data = {}, retry }) => {
  const { message, dashboardUrl } = data;
  const displayMessage = message || 'This link is invalid or no longer available.';

  const handleGoToDashboard = () => {
    if (dashboardUrl) {
      window.location.href = dashboardUrl;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 2,
          padding: 4,
          maxWidth: 420,
          border: '1px solid rgba(255, 255, 255, 0.12)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main' }} />
        <Typography
          variant="h6"
          sx={{ color: 'text.primary', fontWeight: 500 }}
        >
          {displayMessage}
        </Typography>
        {dashboardUrl && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleGoToDashboard}
            sx={{ mt: 1 }}
          >
            Go to Dashboard
          </Button>
        )}
        {retry && (
          <Button
            variant="outlined"
            color="primary"
            onClick={retry}
            sx={{ mt: 1 }}
          >
            Retry
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SessionErrorScreen;
